import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import {
    REQUEST_EDGE_SERVER_ALL_GPUMETRICS,
    REQUEST_EDGE_SERVER_CREATE,
    REQUEST_EDGE_SERVER_DELETE,
    REQUEST_EDGE_SERVER_ENABLE,
    REQUEST_EDGE_SERVER_UPDATE,
    REQUEST_LIST_EDGE_SERVER,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/eisenhower/eisenhowerMsgs";
import {
    EdgeServerEnable,
    EdgeServerHeader,
    EdgeServerID,
} from "userful-chronos-app-common-js/dist/models/eisenhower/edgeSetup";
import "./edgeServerMsgReciever";

export const requestListServers = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_EDGE_SERVER);
};

export const requestAddServer = (payload: EdgeServerHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_EDGE_SERVER_CREATE, payload);
};

export const requestUpdateServer = (payload: EdgeServerHeader) => {
    //wai time
    getGlobalStates().eventBus.sendMsg(REQUEST_EDGE_SERVER_UPDATE, payload);
};

export const requestRemoveServer = (payload: EdgeServerID) => {
    // wait time
    getGlobalStates().eventBus.sendMsg(REQUEST_EDGE_SERVER_DELETE, payload);
};

export const requestEnableEdgeToServer = (payload: EdgeServerEnable) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_EDGE_SERVER_ENABLE, payload);
};

export const requestEdgeServersGpuMetrics = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_EDGE_SERVER_ALL_GPUMETRICS);
};
